import React, { useState, useEffect, useRef } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navRef = useRef(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMenuOpen && navRef.current && !navRef.current.contains(event.target) && !event.target.closest('.menu-toggle')) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  return (
    <header className="header">
      <div className="container header-container">
        <div className="logo">
          <Link to="/" className="logo-link">
            <img src="/logo.png" alt="Neha Shuttering Logo" className="header-logo" />
            <img src="/deslogo.png" alt="Design Logo" className="design-logo" />
          </Link>
        </div>

        <nav ref={navRef} className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
          <ul className="nav-list">
            <li><NavLink to="/" onClick={() => setIsMenuOpen(false)}>Home</NavLink></li>
            <li><NavLink to="/about" onClick={() => setIsMenuOpen(false)}>About Us</NavLink></li>
            <li><NavLink to="/products" onClick={() => setIsMenuOpen(false)}>Our Products</NavLink></li>
            <li><NavLink to="/contact" onClick={() => setIsMenuOpen(false)}>Contact Us</NavLink></li>
            <li className="nav-cta">
              <Link to="/contact" className="btn btn-primary" onClick={() => setIsMenuOpen(false)}>Get Quote</Link>
            </li>
          </ul>
        </nav>

        <div className="menu-toggle" onClick={toggleMenu}>
          <div className={`hamburger ${isMenuOpen ? 'active' : ''}`}></div>
        </div>
      </div>
    </header>
  );
};

export default Header;
